import dayjs from 'dayjs';
import * as R from 'ramda';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
// constants
import { DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT } from '../constants';
// utilities
import { ifElse } from './common';
//////////////////////////////////////////////////

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(timezone);

const getDateTimeFormat = timeSelection => (
  ifElse(
    R.equals(timeSelection, true),
    DEFAULT_DATE_TIME_FORMAT,
    DEFAULT_DATE_FORMAT,
  )
);

const getTimeMeasureToShow = measure => (R.lt(measure, 10) ? `0${measure}` : measure);

const getTimeFrom = date => {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (R.lt(seconds, 60)) return `${seconds}s`;

  if (R.equals(hours, 0)) {
    const secondsToUse = seconds - minutes * 60;

    return `${getTimeMeasureToShow(minutes)}:${getTimeMeasureToShow(secondsToUse)}`;
  }

  const minutesToUse = minutes - (hours * 60);
  const secondsToUse = seconds - (hours * 60 * 60) - (minutesToUse * 60);

  return `${hours}:${getTimeMeasureToShow(minutesToUse)}:${getTimeMeasureToShow(secondsToUse)}`;
};

const currentTimezone = dayjs.tz.guess();

const getDateWithFormat = (date, format) => dayjs(date).tz(currentTimezone).format(format);

const getCurrentDate = (format = DEFAULT_DATE_TIME_FORMAT) => dayjs().tz(dayjs.tz.guess()).format(format);

const toEndOfDayFromDate = item => (
  dayjs(item).endOf('day').format(DEFAULT_DATE_TIME_FORMAT)
);

const calculateElapsedTime = startDate => {
  const now = dayjs().utc();
  const startDateUtc = dayjs.utc(startDate);

  const diff = now.diff(startDateUtc);
  const duration = dayjs.duration(diff);

  const hours = duration.hours();
  const minutes = duration.minutes();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  return ({
    days,
    hours,
    minutes,
  });
};

export {
  getTimeFrom,
  getCurrentDate,
  getDateTimeFormat,
  getDateWithFormat,
  toEndOfDayFromDate,
  getTimeMeasureToShow,
  calculateElapsedTime,
};
